// src/features/links/IconButton.tsx
// IR-1386 r3 (Rotem): "Actions - change to small buttons to save space!!!! -
// same size as platform icon". The Actions column carried two full-width text
// buttons ("Fetch preview", "Dismiss"), which made it the widest column in the
// table for the two controls an analyst uses least often per row.
//
// One component so every action in the column is the SAME size — two
// hand-rolled icon buttons would drift apart the first time one of them gained
// a state. ICON_SIZE is deliberately shared with PlatformIcon's 16px glyph:
// that is the size Rotem measured against.
import type { LucideIcon } from "lucide-react";

/** Matches the PlatformIcon glyph — Rotem's stated reference size. */
export const ICON_SIZE = 16;

interface Props {
  icon: LucideIcon;
  /** Accessible name AND hover tooltip — the label is no longer on screen. */
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Destructive/affirmative tint for the armed Dismiss confirm. */
  tone?: "default" | "danger";
  /** Spins the glyph while a mutation is in flight. */
  busy?: boolean;
}

export function IconButton({ icon: Icon, label, onClick, disabled, tone, busy }: Props) {
  return (
    <button
      type="button"
      // aria-label carries the name the text button used to spell out, so both
      // screen readers and the existing tests still resolve these by name.
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      className="iris-btn"
      style={{
        padding: 4,
        background: "transparent",
        border: "none",
        color: tone === "danger" ? "var(--iris-neon-pink)" : "var(--iris-fg-4)",
      }}
    >
      <Icon size={ICON_SIZE} className={busy ? "animate-spin" : undefined} />
    </button>
  );
}
